import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAppStore } from '../../store/AppStore'
import type { Role } from '../../types/domain'

export function ProtectedRoute({ roles }: { roles: Role[] }) {
  const { state } = useAppStore()
  const location = useLocation()
  if (!state.currentUser) return <Navigate to="/connexion" replace state={{ from: location.pathname }} />
  if (!roles.includes(state.currentUser.role)) return <Navigate to={state.currentUser.role === 'admin' ? '/admin' : '/app'} replace />
  if (!state.currentUser.onboardingComplete && !location.pathname.startsWith('/onboarding')) return <Navigate to={`/onboarding/${state.currentUser.role}`} replace />
  return <Outlet />
}
